import { useState } from "react";
import { useData, useDispatch } from "./DataContext.js";
import { decompress } from "compress-json";

import { FaTrash, FaTrashRestore } from "react-icons/fa";
import { BsQuestionCircle, BsFillExclamationDiamondFill, BsFillCircleFill, BsFillQuestionCircleFill, BsFillCheckCircleFill } from "react-icons/bs";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import Table from "react-bootstrap/Table";
import Navbar from "react-bootstrap/Navbar";
import ListGroup from "react-bootstrap/ListGroup";
import ProgressBar from "react-bootstrap/ProgressBar";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

import Dialog from "./Dialog.js";
import CharPicture from "./CharPicture.js";

//PCDXFQ

const dangerIcon = (<BsFillExclamationDiamondFill className="fs-3 text-danger pb-1 ps-2"/>);
const emptyIcon = (<BsFillExclamationDiamondFill className="fs-3 text-danger pb-1 pe-2 invisible"/>);
const unknownIcon = (<BsFillCircleFill className="text-secondary"/>);
const waitingIcon = (<BsFillQuestionCircleFill className="text-warning"/>);
const doneIcon = (<BsFillCheckCircleFill className="text-success"/>);


export default function Session (props)
{
    const showPopover = (
	<Popover size="lg" className="bg-dark" style={{ borderColor: "#505050" }}>
	    <Popover.Body className="text-light text-center">
		<div>Récupérer et réafficher toutes les parties que vous avez cachées.</div>
            </Popover.Body>
	</Popover>
    );

    const hidePopover = (
	<Popover size="lg" className="bg-dark" style={{ borderColor: "#505050" }}>
	    <Popover.Body className="text-light text-center">
		<div>Cacher et ne plus prendre en compte cette partie. (Par exemple : partie test, partie lancée par erreur, etc.)</div>
            </Popover.Body>
	</Popover>
    );

    const badgePopover = (
	<Popover size="lg" className="bg-dark" style={{ borderColor: "#505050" }}>
	    <Popover.Body className="text-light text-center">
		<div>Questions posées aux personnages.</div>
		<div>(100% n'est pas nécessaire pour résoudre l'enquête.)</div>
		<div className="mt-2 d-flex justify-content-center align-items-center gap-2">
		    <div>{dangerIcon}</div>
		    <div className="text-start">Cette équipe est en retard par rapport aux autres.</div>
		</div>
            </Popover.Body>
	</Popover>
    );

    const errorPopover = (
	<Popover size="lg" className="bg-dark" style={{ borderColor: "#505050" }}>
	    <Popover.Body className="text-light text-center">
		<div>Nombre d'erreurs accumulées.</div>
		<div className="mt-2 d-flex justify-content-center align-items-center gap-2">
		    <div>{dangerIcon}</div>
		    <div className="text-start">Cette équipe a fait beaucoup d'erreur étant donnée sa progression dans l'enquête.</div>
		</div>
            </Popover.Body>
	</Popover>
    );

    const indicePopover = (
	<Popover size="lg" className="bg-dark" style={{ borderColor: "#505050" }}>
	    <Popover.Body className="text-light text-center">
		<div>Nombre de problèmes résolus.</div>
		<div className="mt-2 d-flex justify-content-center align-items-center gap-2">
		    <div>{waitingIcon}</div>
		    <div className="text-start">Problème en cours de résolution.</div>
		</div>
		<div className="mt-2 d-flex justify-content-center align-items-center gap-2">
		    <div>{doneIcon}</div>
		    <div className="text-start">Problème résolu.</div>
		</div>
            </Popover.Body>
	</Popover>
    );

    const globalFinPopover = (
	<Popover className="bg-dark" style={{ borderColor: "#505050" }}>
	    <Popover.Body className="text-light text-center">
		Proportion des <strong>équipes ayant intégralement résolu l'enquête</strong>.
            </Popover.Body>
	</Popover>
    );

    const globalIndicePopover = (
	<Popover className="bg-dark" style={{ borderColor: "#505050" }}>
	    <Popover.Body className="text-light text-center">
		Proportion des <strong>problèmes ayant été résolus</strong>, en moyenne, par les équipes.
            </Popover.Body>
	</Popover>
    );

    const globalBpPopover = (
	<Popover className="bg-dark" style={{ borderColor: "#505050" }}>
	    <Popover.Body className="text-light text-center">
		Proportion des <strong>conseils ayant été associés aux bons personnages</strong>, en moyenne, par les équipes.
            </Popover.Body>
	</Popover>
    );


    const teamScorePopover = (
	<Popover className="bg-dark" style={{ borderColor: "#505050" }}>
	    <Popover.Body className="text-light text-center">
		Les trois équipes ayant <strong>le meilleur score de cybersécurité</strong>&nbsp;: enquête résolue, beaucoup de conseils donnés et peu d'erreurs.
            </Popover.Body>
	</Popover>
    );

    const teamMeanTimePopover = (
	<Popover className="bg-dark" style={{ borderColor: "#505050" }}>
	    <Popover.Body className="text-light text-center">
                Les trois équipes ayant pris le temps de <strong>bien lire et bien comprendre les témoignages</strong>&nbsp;: temps médian de lecture et reflexion par question posée aux personnages.
            </Popover.Body>
	</Popover>
    );

    const teamTotalTimePopover = (
	<Popover className="bg-dark" style={{ borderColor: "#505050" }}>
	    <Popover.Body className="text-light text-center">
                Les trois équipes ayant fini le jeu <strong>le plus rapidement possible</strong>&nbsp;: temps passé jusqu'à la résolution de l'enquête... mais ont-elles bien compris tous les enjeux&nbsp;?
            </Popover.Body>
	</Popover>
    );

    const gData = useData();
    const gDispatch = useDispatch();

    const session = gData.session.sessions[gData.session.currentSessionId];
    const code = (typeof session.code === "string") ? session.code : session.code.toString();
    const codeValue = (
	<span>
	    <span>{code.substring(0,3)}</span>
	    <span className="ps-2">{code.substring(3, 6)}</span>
	</span>
    );
    
    const [tab, setTab] = useState("states");
    const [showCloseDialog, setShowCloseDialog] = useState(false);
    const [showStopDialog, setShowStopDialog] = useState(false);
    //const [showNeedStopDialog, setShowNeedStopDialog] = useState(false);

    function showTab (tabName)
    {
	setTab(tabName);
	/* if ((tabName === "results" || tabName === "solutions") && session.endTime === null) setShowNeedStopDialog(true);
	   else setTab(tabName); */
    }
    
    function closeSession () { gDispatch({ type: "closeSession" }); }
    function stopSession () { gDispatch({ type: "stopSession", endTime: Math.round(Date.now()/1000), code, password: gData.session.password }); }
    function showPlay (show, playId) { gDispatch({ type: "showPlay", show, playId, code, password: gData.session.password }); }

    const closeDialog = (
	<Dialog show={showCloseDialog} hide={() => setShowCloseDialog(false)} confirm={closeSession} confirmTitle="Quitter" title="Quitter la session">
	    <p>Attention : pensez à bien noter le code d'accès suivant si vous souhaitez vous reconnecter plus tard à cette session.</p>
	    <div className="text-center fs-3">{codeValue}</div>
	</Dialog>
    );

    const stopDialog = (
	<Dialog show={showStopDialog} hide={() => setShowStopDialog(false)} confirm={stopSession} confirmTitle="Clore la session" cancel={() => {}} cancelTitle="Plus tard"  title="Clore la session">
	    <p>Les élèves pourront continuer à jouer, mais leur progression ne sera plus enregistrée. Ainsi, vous pourrez accéder aux résultats définitifs et procéder au débriefing.</p>
	</Dialog>
    );

    /* const needStopDialog = (
       <Dialog show={showNeedStopDialog} hide={() => setShowNeedStopDialog(false)} title="Session en cours">
       <p>Vous devez d'abord clore la session pour obtenir les résultats, puis passer au débriefing.</p>
       </Dialog>
     * ); */

    const dateValue = session.creationTime.substring(8, 10) + "/" + session.creationTime.substring(5, 7) + "/" + session.creationTime.substring(0, 4); 


    const playHeads = (
	<tr className="text-center align-middle">
	    <th style={{ width: "350px" }}>Prénoms des élèves</th>
	    
	    <th style={{ width: "175px" }}>Temps de jeu</th>

	    <OverlayTrigger overlay={badgePopover}>
		<th className="user-select-none" style={{ width: "175px" }}>Progression <BsQuestionCircle className="ms-1"/></th>
	    </OverlayTrigger>
	    
	    <OverlayTrigger overlay={errorPopover}>
		<th className="user-select-none" style={{ width: "175px" }}>Erreurs <BsQuestionCircle className="ms-1"/></th>
	    </OverlayTrigger>

	    <OverlayTrigger overlay={indicePopover}>
		<th className="user-select-none" style={{ width: "175px" }}>Problèmes <BsQuestionCircle className="ms-1"/></th>
	    </OverlayTrigger>

	    <th style={{ width: "250px" }}>État de la partie</th>

	    <OverlayTrigger overlay={showPopover}>
		<td className="user-select-none" style={{ width: "40px" }}>
		    <Button variant="dark" className="text-success" onClick={() => showPlay(1, null)}><FaTrashRestore/></Button>
		</td>
	    </OverlayTrigger>

	</tr>
    );


    const primaryClassName = "fs-5";
    const secondaryClassName = "text-secondary fw-medium";

    const badgeMeanRatio = Object
	.values(gData.session.plays)
	.filter((play) => play.playState !== "{}" && play.show === 1)
	.map((play) => {
	    const state = decompress(JSON.parse(play.playState));
	    const emptyState = Object.keys(state).length === 0;
	    const badgeCount = emptyState ? 0 : Object.values(state.badges).filter(badge => badge.state === "opened").length;
	    let badgeRatio = Math.round(badgeCount * 100 / 136);
	    if (badgeRatio > 100) badgeRatio = 100;
	    return badgeRatio;
	})
	.reduce((sum, value) => sum + value, 0) / Object.values(gData.session.plays).length;

    const playData = Object
	.values(gData.session.plays)
	.filter((play) => play.playState !== "{}" && play.show === 1)
	.map((play) => {
	    const state = decompress(JSON.parse(play.playState));

	    let data = { playId: play.playId, name: play.name };
	    
	    data.emptyState = Object.keys(state).length === 0;
	    
	    data.badgeCount = data.emptyState ? 0 : Object.values(state.badges).filter(badge => badge.state === "opened").length;
	    data.badgeRatio = Math.round(data.badgeCount * 100 / 136);
	    if (data.badgeRatio > 100) data.badgeRatio = 100;

	    data.badgeDanger = data.badgeRatio < badgeMeanRatio * 0.8;

	    data.indiceCount = data.emptyState ? 0 : Object
		.values(state.items)
		.filter(item => gData.content.items[item.id].type === "indice")
		.reduce((count, item) => count + (item.found ? 1 : 0), 0);

	    data.errorCount = data.emptyState ? 0 : state.errors;
	    data.errorDanger = (data.indiceCount === 0 && data.errorCount >= 3)
			    || (data.indiceCount === 1 && data.errorCount >= 6)
			    || (data.indiceCount === 2 && data.errorCount >= 10)
			    || (data.indiceCount === 3 && data.errorCount >= 14);

	    data.score = data.emptyState ? 0 : state.score;

	    data.leonie = ! data.emptyState && state.badges.probleme_leonie !== undefined;
	    data.fin = ! data.emptyState && state.badges.fin !== undefined;
	    
	    data.infoCount = data.emptyState ? 0 : Object
		.values(state.items)
		.filter(item => gData.content.items[item.id].type === "info")
		.reduce((count, item) => count + (item.found ? 1 : 0), 0);

	    data.bpCount = data.emptyState ? 0 : Object
		.values(state.items)
		.filter(item => gData.content.items[item.id].type === "bp")
		.reduce((count, item) => count + item.appliedToCharIds.length, 0);

	    data.currentTime = null;
	    if (! data.emptyState && state.badges.start !== undefined)
	    {
		if (session.endTime === null) data.currentTime = Math.round((Date.now() - state.badges.start.time) / 60000);
		else data.currentTime = Math.round((Date.parse(session.endTime) - state.badges.start.time) / 60000);
	    }

	    data.totalTime = null;
	    if (! data.emptyState && state.badges.start !== undefined && state.badges.fin !== undefined)
		data.totalTime = Math.round((state.badges.fin.time - state.badges.start.time) / 60000);

	    data.meanTime = null;
	    if (! data.emptyState && Object.keys(state.badges).length > 0)
	    {
		const times = Object
		    .values(state.badges)
		    .filter((badge) => badge.id.startsWith("done-"))
		    .sort((badge1, badge2) => badge1.time - badge2.time)
		    .map((badge) => badge.time);

		const diffs = times
		    .slice(1)
		    .map((time, i) => time - times[i])
		    .sort((t1, t2) => t1 - t2);

		data.meanTime = Math.round(diffs[Math.round(diffs.length/2)] / 1000);
	    }
	    
	    return data;
	});

    const playItems = playData
	.filter((data) => !data.emptyState)
	.map((data) => {
	    let indiceIcons = (<></>);
	    let gameState = "";
	    let gameClassName = "";

	    if (data.emptyState)
	    {
		gameState = "Écran titre";
		gameClassName = "";
		indiceIcons = (<>{unknownIcon}{unknownIcon}{unknownIcon}</>);
	    }
	    
	    else if (data.fin) {
		gameState = "Enquête terminée";
		gameClassName = "bg-success";
		indiceIcons = (<>{doneIcon}{doneIcon}{doneIcon}</>);
	    }

	    else if (data.indiceCount === 3) {
		gameState = "Problèmes résolus";
		gameClassName = "";
		indiceIcons = (<>{doneIcon}{doneIcon}{doneIcon}</>);
	    }

	    else if (data.indiceCount >= 1) {
		gameState = (<span>Problèmes 2 et 3 en cours<br/><span className="small">(Dounia et Axel)</span></span>);
		gameClassName = "";
		if (data.indiceCount === 1) indiceIcons = (<>{doneIcon}{waitingIcon}{waitingIcon}</>);
		else if (data.indiceCount === 2) indiceIcons = (<>{doneIcon}{doneIcon}{waitingIcon}</>);
	    }

	    else if (data.leonie) {
		gameState = (<span>Problème 1 en cours<br/><span className="small">(Léonie)</span></span>);
		gameClassName = "";
		indiceIcons = (<>{waitingIcon}{unknownIcon}{unknownIcon}</>);
	    }

	    else {
		gameState = "Introduction";
		gameClassName = "";
		indiceIcons = (<>{unknownIcon}{unknownIcon}{unknownIcon}</>);
	    }

	    return (
		<tr key={data.playId} className="text-center align-middle" style={{ height: "50px" }}>
		    <td className="text-center py-0 lh-sm">
			<span className="">{data.name}</span>
		    </td>

		    <td className="text-center py-0 lh-sm">
			<span className={"d-inline-block text-end " + primaryClassName} style={{ width: "40px" }}>{data.totalTime === null ? data.currentTime : data.totalTime}</span>
			<span className={secondaryClassName}>&nbsp;min</span>
		    </td>

		    <td>
			<span>{data.badgeDanger ? emptyIcon : ""}</span>
			<span className={"d-inline-block text-end " + primaryClassName} style={{ width: "40px" }}>{data.badgeRatio}</span>
			<span className={secondaryClassName}>&nbsp;%</span>
			<span>{data.badgeDanger ? dangerIcon : ""}</span>
		    </td>
		    
		    <td>
			<span>{data.errorDanger ? emptyIcon : ""}</span>
			<span className={primaryClassName}>{data.errorCount}</span>
			<span>{data.errorDanger ? dangerIcon : ""}</span>
		    </td>
		    
		    <td>
			<span className={primaryClassName + " d-flex gap-1 justify-content-center"}>{indiceIcons}</span>
		    </td>
		    
		    <td className={"text-center py-0 lh-sm " + gameClassName}>
			<span>{gameState}</span>
		    </td>

		    <OverlayTrigger overlay={hidePopover}>
			<td className="user-select-none">
			    <Button variant="dark" className="text-danger" onClick={() => showPlay(0, data.playId)}><FaTrash/></Button>
			</td>
		    </OverlayTrigger>

		</tr>
	    );
	});

    const realData = playData.filter((data) => data.leonie);
    const teamNb = realData.length;

    const finNb = realData.filter((data) => data.fin).length;
    const finRatio = Math.round(finNb / teamNb * 100);

    const indiceNb = realData.reduce((sum, data) => sum + data.indiceCount, 0);
    const indiceRatio = Math.round(indiceNb / (3 * teamNb) * 100);

    const bpNb = realData.reduce((sum, data) => sum + data.bpCount, 0);
    const bpRatio = Math.round(bpNb / (9 * teamNb) * 100);

    const scoreItems = playData
	.sort((data1, data2) => data2.score - data1.score)
	.slice(0, 3)
	.map((data) => (
	    <ListGroup.Item key={data.playId} className="bg-dark text-light d-flex justify-content-between align-items-center" style={{ borderColor: "#505050" }}>
		<div className="py-0 lh-sm">{data.name}</div>
		<div><span className={primaryClassName}>{data.score}</span><span className={secondaryClassName}>&nbsp;%</span></div>
	    </ListGroup.Item>
	));

    const totalTimeItems = playData
	.filter((data) => data.totalTime !== null)
	.sort((data1, data2) => data1.totalTime - data2.totalTime)
	.slice(0, 3)
	.map((data) => (
	    <ListGroup.Item key={data.playId} className="bg-dark text-light d-flex justify-content-between align-items-center" style={{ borderColor: "#505050" }}>
		<div className="py-0 lh-sm">{data.name}</div>
		<div><span className={primaryClassName}>{data.totalTime}</span><span className={secondaryClassName}>&nbsp;min</span></div>
	    </ListGroup.Item>
	));

    const meanTimeItems = playData
	.filter((data) => data.meanTime !== null)
	.sort((data1, data2) => data2.meanTime - data1.meanTime)
	.slice(0, 3)
	.map((data) => (
	    <ListGroup.Item key={data.playId} className="bg-dark text-light d-flex justify-content-between align-items-center" style={{ borderColor: "#505050" }}>
		<div className="py-0 lh-sm">{data.name}</div>
		<div><span className={primaryClassName}>{data.meanTime}</span><span className={secondaryClassName}>&nbsp;sec</span></div>
	    </ListGroup.Item>
	));

    const bgImageSrc = gData.gameId + "/pictures/title-light.jpg";

    const charCard = (charId) => (
	<div style={{ width: "120px" }}>
	    <Card className={"h-100 d-flex flex-column user-select-none border-4"} style={{ borderColor: gData.content.chars[charId].color }}>
		<Card.Body className="flex-shrink-1 p-0 m-0">
		    <CharPicture charId={charId} width="100%"/>
		</Card.Body>
		<Card.Header className={"h-100 d-flex justify-content-center align-items-center text-center"} style={{ backgroundColor: gData.content.chars[charId].color, borderColor: gData.content.chars[charId].color }}>
		    <div className="fs-7 lh-sm fw-medium text-uppercase">{gData.content.chars[charId].firstName}</div>
		</Card.Header>
	    </Card>
	</div>
    );

    return (
	<>
	    <div className="vw-100 vh-100 opacity-25 position-absolute z-n1" style={{ backgroundImage: "url(" + bgImageSrc + ")", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "50% 50%" }}/>
	    <div className="vh-100 overflow-scroll">
		<Navbar expand="lg" className="bg-black text-light" sticky="top">
		    <Container className="d-flex align-items-center justify-content-between">
			<h1 className="my-2 text-center user-select-none" style={{ fontSize: "32px", textShadow: "#AAF 1px 1px 10px" }}>Qui veut les données d'Irène Hooper&nbsp;?</h1>
			<div className="d-flex align-content-center gap-2">
			    <ButtonGroup>
				<ToggleButton type="radio" variant="light" checked={tab === "states"} onClick={() => showTab("states")}>Progression</ToggleButton>
				<ToggleButton type="radio" variant="light" checked={tab === "results"} onClick={() => showTab("results")}>Résultats</ToggleButton>
				<ToggleButton type="radio" variant="light" checked={tab === "solutions"} onClick={() => showTab("solutions")}>Solutions</ToggleButton>
			    </ButtonGroup>
			    <Button variant="light" onClick={() => setShowCloseDialog(true)}>Quitter</Button>
			</div>
		    </Container>
		</Navbar>
		<Container className="text-light mb-5">
		    {tab === "states" && (
			<>
			    <div className="mt-2 d-flex justify-content-center align-items-start gap-5">
				<div>
				    <div className="fs-5 text-secondary fw-medium">Nom de la session</div>
				    <div className="fs-2">{session.name}</div>
				</div>
				<div>
				    <div className="fs-5 text-secondary fw-medium">Date de création</div>
				    <div className="fs-2">{dateValue}</div>
				</div>
				<div>
				    <div className="fs-5 text-secondary fw-medium">Code d'accès</div>
				    <div className="fs-2 fw-bold">{codeValue}</div>
				</div>
				<div>
				    <div className="fs-5 text-secondary fw-medium">Status</div>
				    <div className="d-flex align-items-center gap-3">
					<div className="fs-2">{session.endTime === null ? "En cours" : "Terminée"}</div>
					{session.endTime === null && (<Button variant="light" onClick={() => setShowStopDialog(true)}>Clore la session</Button>)}
				    </div>
				</div>
			    </div>
			    <div className="mt-5">
				{playItems.length === 0 && (
				    <div className="text-center w-50 m-auto">
					<div className="pt-5 fs-2">Veuillez transmettre à vos élèves<br/>le code d'accès suivant&nbsp;:</div>
					<div className="pt-5 fs-1 fw-medium">{codeValue}</div>
				    </div>
				)}
				{playItems.length > 0 && (
				    <>
					<div className="text-center mb-3 fs-4">{dangerIcon}&nbsp;&nbsp;=&nbsp;&nbsp;équipes potentiellement en difficulté</div>
					<Table bordered variant="dark" className="text-end" style={{ width: "" }}>
					    <thead>{playHeads}</thead>
					    <tbody>{playItems}</tbody>
					</Table>
				    </>
				)}
			    </div>
			</>
		    )}
		    {(tab === "results" && session.endTime === null) && (
			<div className="text-center w-50 m-auto">
			    <div className="pt-5 pb-4 fs-2">Vous devez clore la session pour obtenir les résultats et passer au débriefing.</div>
			    <Button variant="light" size="lg" onClick={() => setShowStopDialog(true)}>Clore la session</Button>
			</div>
		    )}
		    {(tab === "results" && session.endTime !== null) && (
			<>
			    <div className="mt-4 d-flex align-items-end justify-content-center gap-5">
				<div className="w-25 d-flex flex-column gap-3">
				    <div className="fs-4 text-uppercase fw-medium" style={{ textShadow: "#AAF 1px 1px 10px" }}>Résultats collectifs</div>
				    <div>
					<OverlayTrigger overlay={globalFinPopover}>
					    <div>
						<div className="fs-4 user-select-none" style={{ textShadow: "#AAF 1px 1px 10px" }}>Enquêtes terminées <BsQuestionCircle className="ps-1 pb-1"/></div>
						<div className="d-flex align-items-center gap-2">
						    <ProgressBar variant="light" striped now={finRatio} className="bg-dark w-100" style={{ height: "25px", border: "1px solid #505050" }}/>
						    <div><span className={primaryClassName}>{finRatio}</span><span className={secondaryClassName}>&nbsp;%</span></div>
						</div>
					    </div>
					</OverlayTrigger>
				    </div>
				    <div>
					<OverlayTrigger overlay={globalIndicePopover}>
					    <div>
						<div className="fs-4 user-select-none" style={{ textShadow: "#AAF 1px 1px 10px" }}>Problèmes résolus <BsQuestionCircle className="ps-1 pb-1"/></div>
						<div className="d-flex align-items-center gap-2">
						    <ProgressBar variant="light" striped now={indiceRatio} className="bg-dark w-100" style={{ height: "25px", border: "1px solid #505050" }}/>
						    <div><span className={primaryClassName}>{indiceRatio}</span><span className={secondaryClassName}>&nbsp;%</span></div>
						</div>
					    </div>
					</OverlayTrigger>
				    </div>
				    <div>
					<OverlayTrigger overlay={globalBpPopover}>
					    <div>
						<div className="fs-4 user-select-none" style={{ textShadow: "#AAF 1px 1px 10px" }}>Conseils donnés <BsQuestionCircle className="ps-1 pb-1"/></div>
						<div className="d-flex align-items-center gap-2">
						    <ProgressBar variant="light" striped now={bpRatio} className="bg-dark w-100" style={{ height: "25px", border: "1px solid #505050" }}/>
						    <div><span className={primaryClassName}>{bpRatio}</span><span className={secondaryClassName}>&nbsp;%</span></div>
						</div>
					    </div>
					</OverlayTrigger>
				    </div>
				</div>
				<img src={"ada/pictures/chars/robot-big.png"} alt="Robot médical" height="250px"/>
			    </div>
			    <hr className="my-5 text-white opacity-75 w-75 m-auto"/>
			    <div className="d-flex justify-content-around">
				<div className="d-flex flex-column w-25">
				    <OverlayTrigger overlay={teamScorePopover}>
					<div>
					    <div className="fs-4 text-center user-select-none" style={{ textShadow: "#AAF 1px 1px 10px" }}>Les spécialistes <BsQuestionCircle className="ps-1 pb-1"/></div>
					    <div className="fs-5 text-center text-secondary text-medium">(score de cybersécurité)</div>
					    <ListGroup className="mt-3">{scoreItems}</ListGroup>
					</div>
				    </OverlayTrigger>
				</div>
				<div className="d-flex flex-column w-25">
				    <OverlayTrigger overlay={teamMeanTimePopover}>
					<div>
					    <div className="fs-4 text-center user-select-none" style={{ textShadow: "#AAF 1px 1px 10px" }}>Les détectives <BsQuestionCircle className="ps-1 pb-1"/></div>
					    <div className="fs-5 text-center text-secondary text-medium">(temps par question)</div>
					    <ListGroup className="mt-3">{meanTimeItems}</ListGroup>
					</div>
				    </OverlayTrigger>
				</div>
				<div className="d-flex flex-column w-25">
				    <OverlayTrigger overlay={teamTotalTimePopover}>
					<div>
					    <div className="fs-4 text-center user-select-none" style={{ textShadow: "#AAF 1px 1px 10px" }}>Les speed runners <BsQuestionCircle className="ps-1 pb-1"/></div>
					    <div className="fs-5 text-center text-secondary text-medium">(temps total)</div>
					    <ListGroup className="mt-3">{totalTimeItems}</ListGroup>
					</div>
				    </OverlayTrigger>
				</div>
			    </div>
			</>
		    )}
		    {tab === "solutions" && (
			<div className="my-5 d-flex flex-wrap justify-content-between gap-5">
			    <Row>
				<Col sm={2} className="d-flex justify-content-end">{charCard("leonie")}</Col>
				<Col sm={4} className="fs-6">
				    <p className="text-uppercase fw-medium mb-1">Problème</p>
				    <p>Le bras robotique a été volé. Le coupable a utilisé un mail de phishing pour obtenir les codes de désactivation de l'alarme et ainsi dérober le robot.</p>
				</Col>
				<Col sm={3} className="fs-6">
				    <p className="text-uppercase fw-medium mb-1">Informations nécessaires</p>
				    <ul>
					<li>Mail étrange</li>
					<li>Réponse systématique aux mails</li>
				    </ul>
				</Col>
				<Col sm={3} className="fs-6">
				    <p className="text-uppercase fw-medium mb-1">Conseils à donner</p>
				    <ul>
					<li>Vérifier une identité numérique</li>
					<li>Vérifier les liens</li>
					<li>Utiliser un antivirus</li>
				    </ul>
				</Col>
			    </Row>
			    <Row>
				<Col sm={2} className="d-flex justify-content-end">{charCard("axel")}</Col>
				<Col sm={4} className="fs-6">
				    <p className="text-uppercase fw-medium mb-1">Problème</p>
				    <p>Le cloud avec le code source du robot est inaccessible. Le coupable a piraté le compte d'Axel en trouvant son mot de passe bien trop facilement.</p>
				</Col>
				<Col sm={3} className="fs-6">
				    <p className="text-uppercase fw-medium mb-1">Informations nécessaires</p>
				    <ul>
					<li>Mauvaise mémoire</li>
					<li>Photos de chat sur les réseaux</li>
				    </ul>
				</Col>
				<Col sm={3} className="fs-6">
				    <p className="text-uppercase fw-medium mb-1">Conseils à donner</p>
					    <ul>
					<li>Mots de passe complexes</li>
					<li>Gestionnaire de mots de passe</li>
					<li>Maîtriser ses réseaux sociaux</li>
				    </ul>
				</Col>
			    </Row>
			    <Row>
				<Col sm={2} className="d-flex justify-content-end">{charCard("dounia")}</Col>
				<Col sm={4} className="fs-6">
				    <p className="text-uppercase fw-medium mb-1">Problème</p>
				    <p>L'article de recherche portant sur le robot a été modifié. Le coupable s'est fait passé pour Dounia auprès de Lorenzo pour obtenir un accès au document.</p>
				</Col>
				<Col sm={3} className="fs-6">
				    <p className="text-uppercase fw-medium mb-1">Informations nécessaires</p>
				    <ul>
					<li>Réseaux sociaux et vie privée</li>
					<li>Double virtuel</li>
				    </ul>
				</Col>
				<Col sm={3} className="fs-6">
				    <p className="text-uppercase fw-medium mb-1">Conseils à donner</p>
				    <ul>
					<li>Mots de passe complexes</li>
					<li>Gestionnaire de mots de passe</li>
					<li>Maîtriser ses réseaux sociaux</li>
				    </ul>
				</Col>
			    </Row>
			</div>
		    )}
		</Container>
	    </div>
	    {closeDialog}
	    {stopDialog}
	    {/* {needStopDialog} */}
	</>
    );
}
